import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import { IPaymentPreference } from "../store"
import { ServiceType } from "../../Supplier"

export function activityPaymentPreferencesXHR(xhr: XHRInstance) {
	return {
		async getActivityPaymentPreferences(
			params?: Record<string, string | number | undefined>
		): Promise<IListResponse<IPaymentPreference>> {
			return xhr
				.get("/supplier-payment-preferences", {
					params: {
						...params,
						service_type: ServiceType.ActivityBookingServices,
					},
				})
				.then((resp) => resp.data)
		},
		async getActivityPaymentReferences(
			params?: Record<string, string | number | undefined>
		): Promise<IListResponse<{ id: number; name: string }>> {
			return xhr
				.get("/supplier-payment-preferences/references", {
					params: {
						...params,
						service_type: ServiceType.ActivityBookingServices,
					},
				})
				.then((resp) => resp.data)
		},
	}
}
